import { db } from './matudb';
import { get, ref, set, update } from './matuRtdb';

function asUser(user) {
  if (!user) return null;
  return {
    uid: user.id,
    email: user.email || '',
    displayName: user.name || '',
  };
}

function authError(message) {
  const error = new Error(message || 'No se pudo autenticar');
  const text = String(message || '').toLowerCase();
  if (text.includes('already') || text.includes('exist') || text.includes('registr')) {
    error.code = 'auth/email-already-in-use';
  } else if (text.includes('password') || text.includes('contraseña') || text.includes('credential')) {
    error.code = 'auth/wrong-password';
  } else if (text.includes('not found') || text.includes('no exist')) {
    error.code = 'auth/user-not-found';
  } else {
    error.code = 'auth/unknown';
  }
  return error;
}

async function ensureProfile(user) {
  const profileRef = ref(null, `usuarios/${user.uid}`);
  const snap = await get(profileRef);
  const now = new Date().toISOString();
  if (!snap.exists()) {
    await set(profileRef, {
      name: user.displayName || user.email.split('@')[0],
      email: user.email,
      typeU: 'Cuenta Gratis',
      saldo: 0,
      createdAt: now,
      lastLogin: now,
    });
    return;
  }
  await update(profileRef, { lastLogin: now, email: user.email });
}

export async function signInWithEmailAndPassword(_auth, email, password) {
  const { data, error } = await db.auth.signInWithPassword({ email, password });
  if (error || !data?.user) throw authError(error?.message);
  const user = asUser(data.user);
  localStorage.setItem('userUUID', user.uid);
  await ensureProfile(user);
  return { user };
}

export async function createUserWithEmailAndPassword(_auth, email, password, name) {
  const displayName = typeof name === 'string' && name.trim() ? name.trim() : email.split('@')[0];
  const { data, error } = await db.auth.signUp({
    email,
    password,
    options: { data: { name: displayName } },
  });
  if (error || !data?.user) throw authError(error?.message);
  const user = asUser(data.user);
  user.displayName = displayName;
  localStorage.setItem('userUUID', user.uid);
  await ensureProfile(user);
  return { user };
}

export async function sendPasswordResetEmail(_auth, email) {
  const { error } = await db.auth.resetPasswordForEmail(email);
  if (error) throw authError(error.message);
}

export async function signOut() {
  localStorage.removeItem('userUUID');
  const { error } = await db.auth.signOut();
  if (error) throw authError(error.message);
}

export function onAuthStateChanged(_auth, callback) {
  const { data } = db.auth.onAuthStateChange((_event, session) => {
    const user = asUser(session?.user);
    if (user) localStorage.setItem('userUUID', user.uid);
    callback(user);
  });
  return () => data.subscription.unsubscribe();
}

export function getAuth() {
  return auth;
}

export class GoogleAuthProvider {}

export async function signInWithPopup() {
  throw authError('El ingreso con Google no está disponible. Usa correo y contraseña.');
}

function readCachedUser() {
  try {
    const raw = localStorage.getItem('matudb_session');
    if (!raw) return null;
    const session = JSON.parse(raw);
    return asUser(session.user);
  } catch {
    return null;
  }
}

export const auth = {
  get currentUser() {
    return readCachedUser();
  },
  signOut,
  onAuthStateChanged(callback) {
    return onAuthStateChanged(auth, callback);
  },
};

db.auth.getSession().then(({ data }) => {
  const id = data?.session?.user?.id;
  if (id) localStorage.setItem('userUUID', id);
}).catch(() => {});
